export default __webpack_public_path__ + "static/media/1.9e991361.webp";